/* TBET — Mobile sticky cart V02 (Chooser Pill) + bottom-sheet size picker
 *
 * Bar:
 *   [▢ thumb] [Color · Price / SIZE-PILL] [In den Warenkorb]
 *   - Reveals once the real ATC button leaves viewport (IntersectionObserver).
 *   - Size-pill state: "?" muted when none, "S/M/L..." ink when chosen.
 *   - Tap on pill → opens sheet.
 *   - Tap on CTA: if size selected → fires real ATC directly (no sheet).
 *                 if no size → opens sheet.
 *
 * Sheet:
 *   - Slides up. Backdrop tap, Esc, swipe-down on handle, all close.
 *   - Confirm CTA labels "In den Warenkorb · Size {S}" once size is chosen.
 *   - Confirm tap fires real ATC.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('TbetStickyCta');
    var sheet = document.getElementById('TbetSizeSheet');
    if (!bar || !sheet) return;

    var stickyBtn = document.getElementById('TbetStickyCtaBtn');
    var sizePill = document.getElementById('TbetStickyCtaSizePill');
    var sizeValueEl = document.getElementById('TbetStickyCtaSizeValue');
    var priceEl = document.getElementById('TbetStickyCtaPrice');
    var sheetBody = document.getElementById('TbetSizeSheetBody');
    var sheetCta = document.getElementById('TbetSizeSheetCta');
    var sheetCtaDefault = sheetCta ? (sheetCta.getAttribute('data-default-label') || sheetCta.textContent.trim()) : 'In den Warenkorb';
    var dragHandle = sheet.querySelector('.tbet-size-sheet__handle');

    function getRealBtn() {
      return document.querySelector(
        '.product-form__submit, .product-form__buttons [name="add"], product-form button[name="add"]'
      );
    }
    function getRealPickers() {
      return document.querySelectorAll(
        '.product__info-wrapper .product-form__input, .product__info-wrapper variant-radios fieldset'
      );
    }

    var realBtn = getRealBtn();
    if (!realBtn) {
      bar.remove();
      sheet.remove();
      return;
    }

    /* ---------- Reveal: sticky always visible whenever real ATC is NOT in viewport.
                  No "must have been seen" gate — show on page load if ATC starts below the fold. */
    var visible = false;
    function setBarVisible(show) {
      if (show === visible) return;
      visible = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setBarVisible(!entry.isIntersecting);
        });
      }, { threshold: 0 });
      obs.observe(realBtn);
    } else {
      var checkFn = function () {
        var r = realBtn.getBoundingClientRect();
        var inView = r.top < window.innerHeight && r.bottom > 0;
        setBarVisible(!inView);
      };
      window.addEventListener('scroll', checkFn, { passive: true });
      window.addEventListener('resize', checkFn, { passive: true });
      checkFn();
    }

    /* ---------- Detect current size from real picker -------------------- */
    function isSizePicker(picker) {
      var labelEl = picker.querySelector('.form__label, legend, .product-form__label');
      var labelText = (labelEl ? labelEl.textContent : '').trim().toLowerCase();
      if (
        labelText.indexOf('size') >= 0 ||
        labelText.indexOf('sizes') >= 0 ||
        labelText.indexOf('größe') >= 0 ||
        labelText.indexOf('grösse') >= 0
      ) return true;
      var inputs = picker.querySelectorAll('input[type="radio"]');
      if (inputs.length) {
        var values = Array.prototype.map.call(inputs, function (i) { return (i.value || '').trim().toUpperCase(); });
        var sizeTokens = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'OS'];
        var hits = values.filter(function (v) { return sizeTokens.indexOf(v) >= 0; }).length;
        if (hits >= 2) return true;
        var numHits = values.filter(function (v) { return /^\d{2}$/.test(v); }).length;
        if (numHits >= 3) return true;
      }
      return false;
    }
    function getCurrentSize() {
      // PDP V2 uses button-based size grid
      var v2Selected = document.querySelector('.pdp-v2__size-btn.is-selected');
      if (v2Selected) {
        return (v2Selected.getAttribute('data-size-value') || v2Selected.textContent || '').trim();
      }
      var pickers = Array.prototype.filter.call(getRealPickers(), isSizePicker);
      for (var i = 0; i < pickers.length; i++) {
        var picker = pickers[i];
        var checked = picker.querySelector('input[type="radio"]:checked');
        if (checked && checked.value) return checked.value.trim();
        var sel = picker.querySelector('select');
        if (sel && sel.value) return sel.value.trim();
      }
      return null;
    }

    /* ---------- Sync sticky bar state ----------------------------------- */
    function findLivePrice() {
      var el =
        document.querySelector('.product__info-wrapper .price-item--sale:not(.visually-hidden)') ||
        document.querySelector('.product__info-wrapper .price-item--regular:not(.visually-hidden)') ||
        document.querySelector('.pdp-v2__price') ||
        document.querySelector('[data-tbet-price]') ||
        document.querySelector('.product__info-wrapper [data-tbet-cta-price]');
      return el ? el.textContent.replace(/^\s*[—\-]\s*/, '').trim() : '';
    }
    function syncBar() {
      // Price
      if (priceEl) {
        var txt = findLivePrice();
        if (txt) priceEl.textContent = txt;
      }
      // Size pill state + value
      var sz = getCurrentSize();
      if (sizeValueEl) sizeValueEl.textContent = sz || '?';
      if (sizePill) sizePill.setAttribute('data-state', sz ? 'set' : 'empty');
    }

    /* ---------- Sheet open/close ---------------------------------------- */
    function openSheet() {
      populateSheet();
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tbet-no-scroll');
      updateSheetCtaLabel();
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tbet-no-scroll');
    }
    sheet.querySelectorAll('[data-tbet-sheet-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });
    if (sizePill) {
      sizePill.addEventListener('click', function (e) {
        e.preventDefault();
        openSheet();
      });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // If size already chosen → fire real ATC directly.
        if (getCurrentSize()) {
          var liveBtn = getRealBtn();
          if (liveBtn && !liveBtn.hasAttribute('disabled')) {
            liveBtn.click();
            return;
          }
        }
        // No size yet → open the bottom-sheet picker (works for PDP V2 button-grid + legacy radios)
        openSheet();
      });
    }

    /* ---------- Swipe-down on drag handle to close ---------------------- */
    if (dragHandle) {
      var startY = null;
      dragHandle.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY;
      }, { passive: true });
      dragHandle.addEventListener('touchend', function (e) {
        if (startY == null) return;
        var endY = (e.changedTouches[0] || {}).clientY;
        if (endY != null && endY - startY > 40) closeSheet();
        startY = null;
      });
    }

    /* ---------- Populate sheet body — SIZE picker only ------------------ */
    function populateSheet() {
      if (!sheetBody) return;
      sheetBody.innerHTML = '';

      /* PDP V2 path: button-based size grid. Mirror its buttons as chips
         that proxy clicks back into the in-page grid (which has the variant-id
         + price + URL sync logic). */
      var v2grid = document.querySelector('[data-tbet-size-grid]');
      if (v2grid) {
        var v2btns = v2grid.querySelectorAll('.pdp-v2__size-btn');
        if (v2btns.length) {
          var grid = document.createElement('div');
          grid.className = 'tbet-size-sheet__grid';
          v2btns.forEach(function (srcBtn) {
            var val = (srcBtn.getAttribute('data-size-value') || srcBtn.textContent || '').trim();
            var soldOut = srcBtn.classList.contains('is-soldout') || srcBtn.disabled;
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'tbet-size-sheet__chip';
            if (srcBtn.classList.contains('is-selected')) chip.classList.add('is-active');
            if (soldOut) chip.classList.add('is-disabled');
            chip.textContent = val;
            chip.addEventListener('click', function () {
              if (soldOut) return;
              // Proxy the click into the real in-page button so all wiring fires
              srcBtn.click();
              grid.querySelectorAll('.tbet-size-sheet__chip').forEach(function (c) { c.classList.remove('is-active'); });
              chip.classList.add('is-active');
              setTimeout(function () { syncBar(); updateSheetCtaLabel(); }, 80);
            });
            grid.appendChild(chip);
          });
          sheetBody.appendChild(grid);
          return;
        }
      }

      /* Legacy path: radio/select pickers */
      var pickers = Array.prototype.filter.call(getRealPickers(), isSizePicker);

      if (!pickers.length) {
        var note = document.createElement('p');
        note.className = 'tbet-size-sheet__note';
        note.textContent = 'In den Warenkorb legen?';
        sheetBody.appendChild(note);
        return;
      }

      pickers.forEach(function (picker) {
        var grid = document.createElement('div');
        grid.className = 'tbet-size-sheet__grid';

        var inputs = picker.querySelectorAll('input[type="radio"]');
        if (inputs.length > 0) {
          inputs.forEach(function (input) {
            var text = (input.value || '').trim();
            var isSoldOut =
              input.disabled ||
              input.hasAttribute('data-soldout') ||
              input.getAttribute('aria-disabled') === 'true';

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'tbet-size-sheet__chip';
            if (input.checked) btn.classList.add('is-active');
            if (isSoldOut) btn.classList.add('is-disabled');
            btn.textContent = text;

            btn.addEventListener('click', function () {
              if (isSoldOut) return;
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              grid.querySelectorAll('.tbet-size-sheet__chip').forEach(function (c) {
                c.classList.remove('is-active');
              });
              btn.classList.add('is-active');
              setTimeout(function () {
                syncBar();
                updateSheetCtaLabel();
              }, 120);
            });

            grid.appendChild(btn);
          });
        } else {
          var sel = picker.querySelector('select');
          if (sel) {
            Array.from(sel.options).forEach(function (opt) {
              if (!opt.value) return;
              var text = (opt.value || '').trim();
              var soldOut = opt.disabled || /sold[\s-]*out|nicht verfügbar|unavailable/i.test(opt.textContent);
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'tbet-size-sheet__chip';
              if (sel.value === opt.value) btn.classList.add('is-active');
              if (soldOut) btn.classList.add('is-disabled');
              btn.textContent = text;
              btn.addEventListener('click', function () {
                if (soldOut) return;
                sel.value = opt.value;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
                grid.querySelectorAll('.tbet-size-sheet__chip').forEach(function (c) {
                  c.classList.remove('is-active');
                });
                btn.classList.add('is-active');
                setTimeout(function () {
                  syncBar();
                  updateSheetCtaLabel();
                }, 120);
              });
              grid.appendChild(btn);
            });
          }
        }
        sheetBody.appendChild(grid);
      });
    }

    /* ---------- Update sheet confirm CTA label -------------------------- */
    function updateSheetCtaLabel() {
      if (!sheetCta) return;
      var sz = getCurrentSize();
      if (sz) {
        sheetCta.textContent = sheetCtaDefault + ' · Size ' + sz;
      } else {
        sheetCta.textContent = sheetCtaDefault;
      }
    }

    /* ---------- Sheet confirm CTA → fires real ATC ---------------------- */
    if (sheetCta) {
      sheetCta.addEventListener('click', function () {
        var liveBtn = getRealBtn();
        if (!liveBtn) return;
        var needsSize = liveBtn.hasAttribute('data-tbet-needs-size') || !getCurrentSize();
        if (liveBtn.hasAttribute('disabled') || needsSize) {
          // No size yet → flash but DON'T close. User must pick a chip first.
          sheetCta.classList.add('tbet-flash');
          setTimeout(function () { sheetCta.classList.remove('tbet-flash'); }, 1200);
          return;
        }
        liveBtn.click();
        setTimeout(closeSheet, 350);
      });
    }

    /* ---------- Listen for variant changes anywhere on the page --------- */
    document.addEventListener('change', function (e) {
      if (e.target.closest('.product-form__input, variant-radios, variant-selects, variant-radios-mixed')) {
        setTimeout(syncBar, 80);
      }
    });
    // PDP V2 button-based size grid: button click → resync sticky bar
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pdp-v2__size-btn')) {
        setTimeout(syncBar, 80);
      }
    });

    /* ---------- Esc closes sheet ---------------------------------------- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });

    syncBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
